import React, { useEffect, useState } from 'react';

const ElapsedTime = ({ startTime }) => {
  const [elapsedTime, setElapsedTime] = useState('');

  useEffect(() => {
    const calculateElapsedTime = () => {
      const now = new Date();
      const diff = now - new Date(startTime);

      const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
      const months = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
      const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setElapsedTime(`${years} years, ${months} months, ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`);
    };

    calculateElapsedTime(); // Calculate immediately

    const interval = setInterval(calculateElapsedTime, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return <p className="text-m">Time since registration: {elapsedTime}</p>;
};

export default ElapsedTime;
